module.exports = __webpack_public_path__ + "img/y- (15).e9a47251.jpg";